module.exports = __webpack_public_path__ + "assets/welder.svg?596deeab0e4288e237ec88bfcd74ad7a";